import { getMessages } from '../../../../../../../store/constants';

export const DATEPICKER_FROM_PLACEHOLDER = getMessages().getText('datepicker.label.from');
export const DATEPICKER_TO_PLACEHOLDER = getMessages().getText('datepicker.label.to');
export const DATEPICKER_DATE_PLACEHOLDER = getMessages().getText('datepicker.label.date');

export const MAX_DAY = 31;
export const MAX_MONTH = 12;
